import dynamic from "next/dynamic";
const MarqueeGridComponent = dynamic(()=>import("./marquee-grid-component"));
import MarqueeGridConfig from "./marquee-grid-config";
import MarqueeGridAdvancedConfig from "./marquee-grid-advanced-config";
export default {
    MarqueeGridComponent,
    MarqueeGridConfig,
    MarqueeGridAdvancedConfig
};
